import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { UIState } from './types'
import { RootState } from '../types'

export const state: UIState = {
  amountOfThings: 0,
  clusterCreated: false,
  drawer: false,
  drawerComponent: '',
  follow: false,
  followTimerIsActive: false,
  mainGridLoading: {
    establishLoading: true,
    upgradeLocalDBTagsLoading: true,
    loadingThingsSubscription: true
  },
  showEntityType: false,
  showEntityName: false,
  showCluster: false,
  showSnackBar: false,
  snackBarText: '',
  snackBarButtonClose: true,
  showThingInfo: false,
  thingInfo: {},
  trailView: false,
  temperatureByTimeView: false,
  selectionItemInDetail: false
}

const namespaced = true

export const uiState: Module<UIState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
